import React, { FC } from 'react';

import { ModalFooter, ModalTitle, ModalHeader } from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { Switch } from '@epoch-ui/components/Switch/switch';
import { StepBar } from '@epoch-components/step-bar/StepBar';

import { usePlusOneRsvpControlModalContext } from '../plusOneRsvpControlContext';

export const SetUpdateNotificationsForPlusOneContent: FC = () => {
  const { sendNotifications, setSendNotifications, ownerGuest, navigation } =
    usePlusOneRsvpControlModalContext();

  return (
    <>
      <ModalHeader className="tw-m-0 tw-text-black">
        <ModalTitle className="tw-mb-0 tw-text-2xl tw-font-medium">
          Send update notifications?
        </ModalTitle>
      </ModalHeader>
      <div className="tw-space-y-4 tw-text-black">
        <span className="tw-leading-5">
          Let {ownerGuest.firstName} know their plus one guest&apos;s RSVP has been updated.
        </span>
        <div className="tw-flex tw-items-start tw-gap-4 tw-self-stretch">
          <div className="tw-flex tw-flex-col tw-gap-1">
            <span id="send-notifications-label" className="tw-font-medium">
              Send update notifications
            </span>
            <span className="tw-text-xs tw-leading-4 tw-text-primary-grey">
              Update notifications will be sent in accordance with the guest&apos;s{' '}
              <a
                href="https://help.epochapp.com/articles/update-your-profile-and-settings"
                target="_blank"
                rel="noreferrer"
              >
                notification settings
              </a>
            </span>
          </div>
          <Switch
            checked={sendNotifications}
            onCheckedChange={(checked) => setSendNotifications(checked)}
            aria-labelledby="send-notifications-label"
          />
        </div>
      </div>
      <ModalFooter className="tw-mt-0 tw-flex tw-flex-row tw-justify-end tw-text-black">
        <div className="tw-flex tw-flex-1 tw-items-center">
          <StepBar
            totalSteps={navigation.totalStepNumber}
            currentStep={navigation.currentStepNumber}
          />
        </div>
        <div className="tw-flex tw-flex-row tw-justify-center tw-gap-4">
          <Button
            size="sm"
            onClick={navigation.onClickBack}
            className="tw-flex-1 tw-rounded-xl"
            variant="secondary"
          >
            Back
          </Button>
          <Button
            size="sm"
            loading={navigation.loading}
            className="tw-flex-1 tw-rounded-xl"
            variant="primary"
            onClick={navigation.onClickSubmit}
          >
            Update RSVP
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
